import React, { forwardRef, useState } from 'react'

import { Box } from 'widgets/Box'
import { ConditionalWrapper } from 'widgets/ConditionalWrapper'
import { ControlProps } from 'widgets/Field/types'
import { Icon } from 'widgets/Icon'
import { Text } from 'widgets/Text'

import { StyledIconContainer, StyledTextInput } from './styled'

export const TextInput: React.FC<ControlProps> = forwardRef(
  (
    {
      placeholder = '',
      placeholderTextColor,
      error = undefined,
      editable = true,
      disabled = false,
      icon,
      secureTextEntry = false,
      name,
      onChange,
      onBlur,
      onFocus,
      value,
      multiline,
      numberOfLines,
      backgroundColor = 'greyDark',
      style,
      cursor,
      format,
    }: ControlProps,
    ref: any,
  ) => {
    const [focused, setFocused] = useState(false)

    const handleBlur = () => {
      setFocused(false)
      if (onBlur) {
        onBlur(name)
      }
    }

    const handleFocus = () => {
      setFocused(true)

      if (onFocus) {
        onFocus(name)
      }
    }

    return (
      <>
        <ConditionalWrapper
          condition={!!icon}
          wrapper={(children: any) => (
            <Box display='flex' flexDirection='row'>
              <StyledIconContainer focused={focused} justifyContent='center' align='center'>
                <Icon name={`${icon}`} size={18} color='text' />
              </StyledIconContainer>
              <Box flex={1}>{children}</Box>
            </Box>
          )}
        >
          <StyledTextInput
            ref={ref}
            multiline={multiline}
            editable={editable}
            disabled={disabled}
            icon={icon}
            backgroundColor={backgroundColor}
            placeholder={placeholder}
            placeholderTextColor={placeholderTextColor}
            secureTextEntry={secureTextEntry}
            error={!!error}
            focused={focused}
            onChangeText={onChange ? onChange(name) : null}
            onBlur={handleBlur}
            value={format ? format(value) : value || ''}
            numberOfLines={numberOfLines}
            onFocus={handleFocus}
            cursor={cursor}
            style={style}
          />
        </ConditionalWrapper>
        {error ? (
          <Box padding={{ vertical: 'xs' }}>
            <Text type='error' fontWeight='medium' fontSize='sm'>
              {error}
            </Text>
          </Box>
        ) : null}
      </>
    )
  },
)
